// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fbd85930","513":"2e1d1c4b","703":"97028601","787":"97a8d03d"}[chunkId] + ".chunk.js";
};